@if (loading()) {
    <div class="large-number-display skeleton">
        <div class="content">
            <div class="background-icon-skeleton"></div>
            <div class="value-container">
                <span class="skeleton-text value-skeleton"></span>
            </div>
            <div class="label-container">
                <span class="skeleton-text label-skeleton"></span>
            </div>
        </div>
    </div>
} @else {
    <div
        class="large-number-display"
        [class.empty]="isEmpty()"
        [style.--state-accent]="stateConfig().accent"
        [style.--state-text]="stateConfig().text"
    >
        @if (isEmpty()) {
            <div class="content">
                @if (emptyStateIcon()) {
                    <div class="background-icon">
                        <i [class]="emptyStateIcon()"></i>
                    </div>
                }
                <div class="empty-state">
                    <span class="empty-message">{{ emptyStateMessage() }}</span>
                </div>
            </div>
        } @else {
            <div class="content">
                @if (icon()) {
                    <div class="background-icon">
                        <i [class]="icon()"></i>
                    </div>
                }
                <div class="value-container">
                    <span class="value">{{ value() }}</span>
                </div>
                <div class="label-container">
                    <span class="label">{{ label() }}</span>
                </div>
            </div>
        }
    </div>
}
